// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-bubble-callout {
  animation: bubble-reveal 400ms cubic-bezier(0.215, 0.61, 0.17, 1.14);
  border-radius: 4px;
}
.bolt-bubble-callout.bolt-bubble-fullscreen {
  margin: 0px;
  max-height: none;
  max-width: none;
  height: auto;
  width: auto;
  border-radius: 0px;
}
.bolt-bubble-callout.fade-out {
  animation: bubble-dismiss 200ms cubic-bezier(0.55, 0.055, 0.675, 0.19);
}
.bolt-bubble-callout.left-primary {
  margin-left: 8px;
}
.bolt-bubble-callout.left-primary .bolt-bubble-beak {
  left: -7.071px;
}
.bolt-bubble-callout.right-primary {
  margin-right: 8px;
}
.bolt-bubble-callout.right-primary .bolt-bubble-beak {
  right: -7.071px;
}
.bolt-bubble-callout.top-primary {
  margin-top: 8px;
}
.bolt-bubble-callout.top-primary .bolt-bubble-beak {
  top: -7.071px;
}
.bolt-bubble-callout.bottom-primary {
  margin-bottom: 8px;
}
.bolt-bubble-callout.bottom-primary .bolt-bubble-beak {
  bottom: -7.071px;
}
.bolt-bubble-callout.left-secondary .bolt-bubble-beak {
  left: 16px;
}
.bolt-bubble-callout.right-secondary .bolt-bubble-beak {
  right: 16px;
}
.bolt-bubble-callout.top-secondary .bolt-bubble-beak {
  top: 16px;
}
.bolt-bubble-callout.bottom-secondary .bolt-bubble-beak {
  bottom: 16px;
}
.bolt-bubble-callout.center-h .bolt-bubble-beak {
  left: calc(50% - 14.142px / 2);
}
.bolt-bubble-callout.center-v .bolt-bubble-beak {
  top: calc(50% - 14.142px / 2);
}
.bolt-bubble-callout[class*=left][class*=top] {
  transform-origin: left top;
}
.bolt-bubble-callout[class*=right][class*=top] {
  transform-origin: right top;
}
.bolt-bubble-callout[class*=left][class*=bottom] {
  transform-origin: left bottom;
}
.bolt-bubble-callout[class*=right][class*=bottom] {
  transform-origin: right bottom;
}
.bolt-bubble-callout.left-primary.center-v {
  transform-origin: left center;
}
.bolt-bubble-callout.right-primary.center-v {
  transform-origin: right center;
}
.bolt-bubble-callout.center-h.top-primary {
  transform-origin: center top;
}
.bolt-bubble-callout.center-h.bottom-primary {
  transform-origin: center bottom;
}

.bolt-bubble-beak {
  position: absolute;
  width: 14.142px;
  height: 14.142px;
  background: rgba(255, 255, 255, 1);
  background: var(--callout-background-color,rgba(255, 255, 255, 1));
  transform: rotate(45deg);
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-bubble-beak {
  box-shadow: none;
  border-left: 2px solid rgba(0, 120, 212, 1);
  border-left: 2px solid var(--focus-border-color,rgba(0, 120, 212, 1));
  border-top: 2px solid rgba(0, 120, 212, 1);
  border-top: 2px solid var(--focus-border-color,rgba(0, 120, 212, 1));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-bubble-beak {
  box-shadow: none;
  border-left: 2px solid rgba(0, 120, 212, 1);
  border-left: 2px solid var(--focus-border-color,rgba(0, 120, 212, 1));
  border-top: 2px solid rgba(0, 120, 212, 1);
  border-top: 2px solid var(--focus-border-color,rgba(0, 120, 212, 1));
}

.bolt-bubble-content {
  background: rgba(255, 255, 255, 1);
  background: var(--callout-background-color,rgba(255, 255, 255, 1));
  border-radius: 4px;
  max-width: 368px;
}

.bolt-bubble-text-only {
  max-width: 240px;
  padding: 16px;
}

.bolt-bubble-text {
  padding-bottom: 0px;
}
.bolt-bubble-text.no-buttons {
  padding-bottom: 16px;
}

.bolt-bubble-description {
  color: rgba(0, 0, 0, .9);
  color: var(--text-primary-color,rgba(0, 0, 0, .9));
}

.bolt-bubble-close.close-button.bolt-button.subtle {
  top: 12px;
  right: 12px;
  position: absolute;
  font-size: 1rem;
  padding: 3px;
}

@keyframes bubble-reveal {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes bubble-dismiss {
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0.8);
  }
}

/*# sourceMappingURL=TeachingBubble.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/TeachingBubble/TeachingBubble.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/bin/Components/TeachingBubble/TeachingBubble.css"],"names":[],"mappings":"AAQA;EACI,oEAAA;EACA,kBC2SQ;AClTZ;AFSI;EACI,WAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AEPR;AFUI;EACI,sEAAA;AERR;AFWI;EACI,gBC+RI;ACxSZ;AFUQ;EACI,cAAA;AERZ;AFYI;EACI,iBCwRI;AClSZ;AFWQ;EACI,eAAA;AETZ;AFaI;EACI,eCiRI;AC5RZ;AFYQ;EACI,aAAA;AEVZ;AFcI;EACI,kBC0QI;ACtRZ;AFaQ;EACI,gBAAA;AEXZ;AFeI;EACI,UC2QK;ACxRb;AFgBI;EACI,WCuQK;ACrRb;AFiBI;EACI,SCmQK;AClRb;AFkBI;EACI,YC+PK;AC/Qb;AFmBI;EACI,8BAAA;AEjBR;AFoBI;EACI,6BAAA;AElBR;AFqBI;EACI,0BAAA;AEnBR;AFqBI;EACI,2BAAA;AEnBR;AFqBI;EACI,6BAAA;AEnBR;AFqBI;EACI,8BAAA;AEnBR;AFsBI;EACI,6BAAA;AEpBR;AFsBI;EACI,8BAAA;AEpBR;AFsBI;EACI,4BAAA;AEpBR;AFsBI;EACI,+BAAA;AEpBR;;AFwBA;EACI,kBAAA;EACA,eAxGoB;EAyGpB,gBAzGoB;EA2GpB,kCCgFqB;ED/ErB,kEAAA;EEtBF,wBAAwB;ADkTlB;AChTR;EFwBQ,gBAAA;EACA,2CAAA;EEtBN,qEAAqE;EDgT/D,0CAAA;ED5RA,oEAAA;AEjBR;AACA;EACE,gBAAgB;EAChB,2CAA2C;EFoB7C,qEAAA;EACI,0CCqEqB;EDpErB,oEC4LQ;AC9MZ;;AAEA;EFoBA,kCAAA;EACI,kEAAA;EACA,kBCkMS;ECpNX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EFmBd,aAAA;AEjBJ;;AAEA;EFoBA,mBAAA;AElBA;AACA;EACE,oBAAoB;AFoBtB;;AEjBA;EFoBI,wBAAA;EACA,kDCiIS;ACnJb;;AAEA;EFoBA,SAAA;EACI,WAAA;EElBF,kBFmBM;EElBN,eFmBM;EElBN,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IFqBd,qBAAA;EACI;EEnBF;IFqBM,UAAA;IEnBJ,mBAAmB;EFqBnB;AEnBJ;AACA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,qBAAqB;EACvB;AACF;;AAEA,6CAA6C","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
